import { render, staticRenderFns } from "./textBefore.vue?vue&type=template&id=d903297c&scoped=true"
import script from "./textBefore.vue?vue&type=script&lang=js"
export * from "./textBefore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d903297c",
  null
  
)

export default component.exports